"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaults_1 = require("./defaults");
const api_1 = require("./web/api");
const browser_1 = require("./web/browser");
class WebAnalytics {
    constructor() {
        this.api = new api_1.Api();
    }
    configure(config) {
        const { consumerKey, apiKey, entityKey = '', endpoint = defaults_1.default.endpoint, } = config;
        const W = browser_1.default.getWindow();
        // tslint:disable-next-line: only-arrow-functions
        W.sea = function () {
            (W.sea.q = W.sea.q || []).push(arguments);
        };
        W.sea.l = new Date();
        W.sea('create', consumerKey, apiKey, entityKey, endpoint);
        this.api.initialize();
    }
    send(...args) {
        this.api.processQueue([['send', ...args]]);
    }
    set(...args) {
        this.api.processQueue([['set', ...args]]);
    }
}
exports.default = WebAnalytics;
